<template>
  <div class="insurances">
    <page-top v-bind="pageTop" />
    <main>
      <v-container class="insurances__list">
        <v-heading level="h6">Clique em seu convênio para ver as categorias que o URC atende</v-heading>
        <insurances-list />
        <aside><insurances-faq /></aside>
      </v-container>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Lottie from 'vue-lottie';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Card from '@/components/layout/Card.vue';
import PageTop from '@/components/layout/PageTop.vue';
import PreSchedule from '@/components/widgets/PreSchedule.vue';
import SearchInput from '@/components/widgets/SearchInput.vue';
import InsurancesList from '@/components/insurances/InsurancesList.vue';
import InsurancesFaq from '@/components/insurances/InsurancesFaq.vue';

const meta = [
  {
    vmid: 'og:title',
    name: 'og:title',
    template: 'Convênios Atendidos',
  },
  {
    vmid: 'description',
    name: 'description',
    content: 'Conheça os convênios médicos parceiros da URC. Verifique sempre com seu convênio quais serviços são credenciados para seu plano.',
  },
  {
    vmid: 'og:description',
    name: 'og:description',
    content: 'Conheça os convênios médicos parceiros da URC. Verifique sempre com seu convênio quais serviços são credenciados para seu plano.',
  },
];

export default {
  name: 'Insurances',
  components: {
    'v-container': Container,
    'v-heading': Heading,
    'v-card': Card,
    'v-lottie': Lottie,
    'page-top': PageTop,
    'pre-schedule': PreSchedule,
    'search-input': SearchInput,
    'insurances-list': InsurancesList,
    'insurances-faq': InsurancesFaq,
  },
  metaInfo: {
    title: 'Convênios Atendidos',
  },
  computed: {
    ...mapState({
      pageTop: state => state.insurances.page.content,
    }),
  },
  async created() {
    await this.$store.dispatch('insurances/page/getContent');
  },
};
</script>

<style lang="scss" scoped>
$component: '.insurances';
#{$component} {
  padding-bottom: $section-gutter;
  /deep/ .page-top__title {
    color: $color-e;
  }
  main {
    background-color: $bg-gray;
    padding: $section-gutter / 2 $gutter-l $section-gutter;
  }
  &__list {
    display: grid;
    grid-template-columns: 4fr 2fr;
    grid-template-rows: auto;
    grid-gap: 0 $gutter-l;
    margin-bottom: $section-gutter;
    @media screen and (max-width: #{$brakepoint-large}) {
      display: block;
    }
    > .heading {
      grid-column: 1 / 3;
      grid-row: 1;
    }
    ul {
      grid-column: 1 / 2;
      grid-row: 2;
    }
    aside {
      padding: 0;
      grid-column: 2 / 3;
      grid-row: 2;
      .insurances-faq /deep/ ul {
        @media screen and (max-width: #{$brakepoint-large}) and (min-width: #{$brakepoint-medium}) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 0 $gutter-xxxl;
        }
        li {
          @media screen and (max-width: #{$brakepoint-large}) {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
